import React from "react"

const Sales = ({ className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M16 20.5328V27.1995M21.3336 17.8672V27.2005M26.6664 12.5328V27.1995M29.3331 3.20001L17.8051 14.728C17.7431 14.7901 17.6696 14.8394 17.5886 14.873C17.5076 14.9066 17.4208 14.9239 17.3331 14.9239C17.2454 14.9239 17.1586 14.9066 17.0776 14.873C16.9966 14.8394 16.923 14.7901 16.8611 14.728L12.4717 10.3387C12.3467 10.2137 12.1772 10.1435 12.0004 10.1435C11.8236 10.1435 11.6541 10.2137 11.5291 10.3387L2.66641 19.2M5.33359 23.2V27.2M10.6664 17.8672V27.2005"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Sales
